import Offcanvas from 'react-bootstrap/Offcanvas';
import { NavLink } from 'react-router-dom';
import { IconBell, IconColumns, IconList, IconGrid, IconSettings, IconChevronDown } from '../atoms/Icon';

// `badge` + `disabled` marcam uma tela que ainda vai chegar: o item continua no
// menu (para o usuário saber que ela existe e está vindo) mas não é clicável,
// então não há caminho de navegação até ela. O texto fala do que interessa a
// quem usa — quando terá — e não do nosso estágio interno de desenvolvimento.
export const navItems = [
  { to: '/pedidos',       label: 'Pedidos',       icon: IconColumns },
  { to: '/cardapio',      label: 'Cardápio',      icon: IconList },
  { to: '/pdv',           label: 'PDV',           icon: IconBell },
  // badgeShort: a barra inferior dá ~90px por item, onde "Em breve" não cabe.
  { to: '/dashboard',     label: 'Dashboard',     icon: IconGrid, badge: 'Em breve', badgeShort: 'Breve', disabled: true },
  { to: '/configuracoes', label: 'Configurações', icon: IconSettings },
];

function Sidebar({ show, onHide }) {
  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      responsive="lg"
      style={{ '--bs-offcanvas-width': '260px', '--bs-offcanvas-bg': 'var(--color-purple-deep)' }}
    >
      <div className="sidebar-shell">
        <div className="sidebar-brand">
          <img src="/images/icon-horizontal.png" alt="MyPedidos" className="sidebar-brand-logo" />
          <button
            type="button"
            onClick={onHide}
            aria-label="Fechar menu"
            className="d-lg-none sidebar-close-btn"
          >
            <IconChevronDown size={18} style={{ transform: 'rotate(90deg)' }} />
          </button>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => {
            const content = (
              <>
                <span className="sidebar-link-icon">
                  <item.icon size={20} />
                </span>
                <span>{item.label}</span>
                {item.badge && <span className="dev-badge">{item.badge}</span>}
              </>
            );

            // Item desabilitado sai como <span>, não como link: sem href, sem
            // foco de teclado e sem rota — não há como chegar na tela por ele.
            // `aria-disabled` sozinho num <span> sem role não é confiável para
            // leitor de tela — o texto oculto garante o anúncio.
            return item.disabled ? (
              <span
                key={item.to}
                className="sidebar-link disabled"
                aria-disabled="true"
                title="Disponível em breve"
              >
                {content}
                <span className="visually-hidden"> (indisponível)</span>
              </span>
            ) : (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={onHide}
                className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
              >
                {content}
              </NavLink>
            );
          })}
        </nav>
      </div>
    </Offcanvas>
  );
}

export default Sidebar;
